var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Search","single-line":"","hide-details":"","autocomplete":"off","clearable":""},on:{"input":function($event){return _vm.search()}},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }